// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"2":"33f42360","120":"314f0ff4","169":"d868a50c","491":"5227ff75","995":"ee73ee9e"}[chunkId] + ".js";
};